<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import ForeignHealtInsuranceData from '@/data/company-page-data/sompo-sigorta/cross-pages/ForeignHealtInsurance'
export default {
  metaInfo: {
    title: 'Sompo Sigorta Yabancı Uyruklu Sağlık Sigortası Fiyatları',
    meta: [
      {
        name: 'description',
        content: "Türkiye'de oturma izni almak isteyen adaylar Ankara Sigorta yabancı uyruklu sağlık sigortası yaptırabilir. Yabancı uyruklu genel sağlık sigortası sorgulama."
      }
    ]
  },
  name: 'SompoSigortaForeignHealtInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: ForeignHealtInsuranceData.headerContent,
      crossPageContent: ForeignHealtInsuranceData.crossPageContent,
      faqTitle: ForeignHealtInsuranceData.faqTitle,
      faqTitleDesc: ForeignHealtInsuranceData.faqTitleDesc,
      getPrice: ForeignHealtInsuranceData.getPrice
    }
  }
}
</script>
